module.exports = __webpack_public_path__ + "img/cunchu.7901db81.png";